import { MenuOutlined } from "@mui/icons-material";
import { Button, Menu } from "@mui/material";
import PopupState, { bindMenu, bindTrigger } from "material-ui-popup-state";
import { useNavigate } from "react-router-dom";

import { Flex } from "../../style";
import { colors, sizes } from "../../variables";
import { ITEMS } from "../Navbar/constants";

export default function MobileMenu() {
  const navigate = useNavigate();
  return (
    <PopupState
      variant="popover"
      popupId="demo-popup-menu"
      className="mobile-menu"
    >
      {(popupState) => (
        <>
          <MenuOutlined
            sx={{ fontSize: sizes.xl }}
            {...bindTrigger(popupState)}
            className="mobile-menu"
          />
          <Menu {...bindMenu(popupState)}>
            <Flex
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
              p={`0 ${sizes.sm}`}
              gap={sizes.sm}
            >
              {ITEMS.map(({ path, title, isCTA }, index) => {
                const key = `navbar-item-${index}`;
                return (
                  <Button
                    variant="text"
                    sx={{
                      color: colors.dark,
                      borderColor: colors.primary,
                      "&:hover": {
                        backgroundColor: colors.secondary,
                        borderColor: colors.primary,
                      },
                    }}
                    aria-label="Navigate to another route on mobile phones"
                    key={key}
                    onClick={() => {
                      navigate(path);
                      popupState.close();
                    }}
                  >
                    {title}
                  </Button>
                );
              })}
            </Flex>
          </Menu>
        </>
      )}
    </PopupState>
  );
}
